import React from 'react';

/**
 * Displayed when an impersonation session has ended in Staff Portal.
 */
const ImpersonationEnded = () => {
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
      <div className="card shadow" style={{ maxWidth: '500px' }}>
        <div className="card-body text-center p-5">
          <i className="bi bi-check-circle-fill text-success fs-1 mb-3"></i>
          <h4 className="mb-3">Session Ended</h4>
          <p className="text-muted mb-4">
            Your view session has ended. You can safely close this window.
          </p>
          <div className="d-grid gap-2">
            <button
              className="btn btn-primary"
              onClick={() => window.close()}
            >
              Close Window
            </button>
          </div>
          <small className="text-muted mt-3 d-block">
            If this window doesn't close, you can safely close it manually.
          </small>
        </div>
      </div>
    </div>
  );
};

export default ImpersonationEnded;
